import { render } from "./BakeryApp.vue?vue&type=template&id=033e5ca2"
import script from "./BakeryApp.vue?vue&type=script&lang=js"
export * from "./BakeryApp.vue?vue&type=script&lang=js"

import "./BakeryApp.vue?vue&type=style&index=0&id=033e5ca2&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__